export default __webpack_public_path__ + "static/media/sumup.439b1a2a.png";